module.exports = __webpack_public_path__ + "img/orderok.32e1b186.svg";